import generateCrudConstants from './baseCrudConstants';
import mirrorCreator from 'mirror-creator';

export default {
  ...mirrorCreator([
    'SUBMISSION_FORM_VALIDATION_REQUEST',
    'SUBMISSION_FORM_VALIDATION_SUCCESS',
    'SUBMISSION_FORM_PREPARE_PREVIEW',
    'SUBMISSION_FORM_CLEAR_PREVIEW',
    'SUBMISSION_FORM_STEP_COMPLETED',
    'SUBMISSION_FORM_SWITCH'
  ]),
  ...generateCrudConstants('EVENT', 'CU'),
  ...generateCrudConstants('IMAGE', 'CRD'),
  ...generateCrudConstants('DRAFT', 'C'),
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/submissionFormConstants.js